import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import itemsReducer from './slices/itemsSlice';
import assimilationsReducer from './slices/assimilationsSlice';
import characteristicsReducer from './slices/characteristicsSlice';
import skillsReducer from './slices/skillsSlice';
import instinctsReducer from './slices/instinctsSlice';
import homebrewsReducer from './slices/homebrewsSlice';

const combinedReducer = combineReducers({
    auth: authReducer,
    skills: skillsReducer,
    instincts: instinctsReducer,
    characteristics: characteristicsReducer,
    assimilations: assimilationsReducer,
    homebrews: homebrewsReducer,
    items: itemsReducer,
});
// Session replacement also clears cached data belonging to the previous account.
const rootReducer = (state, action) => {
  const next = combinedReducer(state, action);
  if (state && state.auth.sessionId !== next.auth.sessionId) return combinedReducer({ auth: next.auth }, { type: 'session/resetCaches' });
  return next;
};

export const store = configureStore({
  devTools: process.env.NODE_ENV !== 'production',
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export default store;
